/* jshint esversion: 6 */
let RecurlyModule = {
    loadRecurly: function(app, updateCallback) {
        if (!window.recurly) {
            let callback = () => {
        			updateCallback(true);
                },
                body = document.getElementsByTagName('body'),
                head = document.getElementsByTagName('head'),
                script = document.createElement('script'),
                styles = document.createElement('link');

            script.type = 'text/javascript';
            script.src = 'https://js.recurly.com/v4/recurly.js';
            script.onreadystatechange = callback;
            script.onload = callback;

            styles.rel = 'stylesheet';
            styles.type = 'text/css';
            styles.href = 'https://js.recurly.com/v4/recurly.css';

            head[0].appendChild(styles);
            body[0].appendChild(script);
        } else {
            updateCallback(true);
        }
    },
    generateRecurlyFields: function(app, id) {
        let jsKey = app.config.jsKey;
        recurly.configure({
            publicKey: jsKey,
            fields: {
                all: {
                    style: {
                        'fontFamily': 'Roboto',
                        'fontColor': '#777777',
                        'invalid': {
                            'fontColor': '#d93600'
                        }
                    }
                },
                card: {
                    style: {
                        padding: '0 10px'
                    }
                },
            }

        });
    },
    generateName: function(name) {
        if (typeof name === 'string' && name.match("@")) {
            let nameParts = name.split("@"),
                first = nameParts[0],
                last = nameParts[1];
            return [first, last];
        }
        return [];
    }
};

export default RecurlyModule;
